import React, { useContext } from 'react';
import Icon from '@legacy-vfuk/core-icon';
import {
  SaveOptionContainer,
  SaveTextWrapper,
  SaveIconWrapper,
} from './styles/SaveArticleIcon.styles';
import { SaveArticleIconProps } from './types/SaveArticleIcon.types';
import { IconWithTextWrapper } from '../pageBuilder/Elements/ArticleCard/styles/ArticleCard.styles';
import { DirectionContext } from '../../contexts/DirectionContext';
import fireButtonAndLinkClicksEvent from '../../helpers/fireButtonAndLinkClicksEvent';

const SaveArticleIcon: React.FC<SaveArticleIconProps> = ({
  show,
  saveLabel,
  onArticle,
  useSmallerText,
  handleSaveClick,
}) => {
  const directionContext = useContext(DirectionContext);

  const handleClick: React.MouseEventHandler = e => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    handleSaveClick();

    fireButtonAndLinkClicksEvent({
      event_action: 'button click',
      event_label: 'Save open',
    });
  };

  if (!show) {
    return null;
  }

  if (onArticle) {
    return (
      <SaveOptionContainer onClick={handleClick} direction={directionContext}>
        <SaveIconWrapper>
          <Icon name="bookmark" />
        </SaveIconWrapper>
        <SaveTextWrapper style={{ direction: 'ltr' }}>
          {saveLabel}
        </SaveTextWrapper>
      </SaveOptionContainer>
    );
  }

  return (
    <IconWithTextWrapper useSmallerText={useSmallerText} onClick={handleClick}>
      <SaveIconWrapper>
        <Icon name="bookmark" size={3} />
      </SaveIconWrapper>
    </IconWithTextWrapper>
  );
};

export default SaveArticleIcon;
